import { render, staticRenderFns } from "./AdminDipartimentiUnitnView.vue?vue&type=template&id=d94103a8&"
import script from "./AdminDipartimentiUnitnView.vue?vue&type=script&lang=ts&"
export * from "./AdminDipartimentiUnitnView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports